import type {
  ControlResultListItemResponseDto,
  ControlStatusResponseDto,
} from "@/spz-api/model";
import { SearchableSelect } from "@spz/ui/components/searchable-select";
import type { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

export const ControlResultStatusFilter = ({
  table,
  steps,
}: {
  table: Table<ControlResultListItemResponseDto>;
  steps: ControlStatusResponseDto[];
}) => {
  const { t } = useTranslation();

  const rawValue =
    (table.getColumn("workflow_step_uuid")?.getFilterValue() as string[]) ?? [];

  const statusOptions = steps.map((step) => ({
    label: t(step.labelKeyName),
    value: step.id,
  }));

  const onFilterChange = (newStatuses: string[]) => {
    table.setColumnFilters((current) => {
      const filtered = current.filter((f) => f.id !== "workflow_step_uuid");
      return [...filtered, { id: "workflow_step_uuid", value: newStatuses }];
    });
  };

  return (
    <SearchableSelect
      placeholder="Status"
      options={statusOptions}
      value={rawValue}
      onSelect={onFilterChange}
      multi
      variant="ghost"
    />
  );
};
